<template>
  <div>
    <v-row>
      <v-col cols="6">
        <div
          v-if="value.schema_type && value.schema_type.length > 0"
          class="mt-1"
        >
          <span class="caption">
            Schema:
          </span>
          <v-chip
            v-for="(schema, index) in value.schema_type"
            :key="index"
            :color="color"
            class="mr-2 mb-2"
            outlined
            label
            small
          >
            {{ schema }}
          </v-chip>
        </div>
        <span
          v-else
          class="caption"
        >
          <span class="caption">
            Schema:
          </span>
          <span
            class="caption font-italic"
          >
            No data
          </span>
        </span>
      </v-col>
      <v-col cols="6">
        <span class="caption">
          Lang:
        </span>
        <span
          v-if="value.lang"
          class="caption font-weight-bold"
        >
          {{ value.lang.string }}
        </span>
        <span
          v-else
          class="caption font-italic"
        >
          No data
        </span>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="6">
        <span class="caption">
          Internal Links:
        </span>
        <span
          v-if="value.anchors"
          class="caption font-weight-bold"
        >
          {{ value.anchors.size - value.anchors.outboundSize }}
        </span>
        <span
          v-else
          class="caption font-italic"
        >
          No data
        </span>
      </v-col>
      <v-col cols="6">
        <span class="caption">
          External Links:
        </span>
        <span
          v-if="value.anchors"
          class="caption font-weight-bold"
        >
          {{ value.anchors.outboundSize }}
        </span>
        <span
          v-else
          class="caption font-italic"
        >
          No data
        </span>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col cols="6">
        todo
      </v-col>
      <v-col cols="6">
        todo
      </v-col>
    </v-row> -->
  </div>
</template>
  
  <script>
  export default {
      props: {
          value: {
              type: Object,
              default: () => ({})
          },
      },
  }
  </script>

  
  